import PropTypes from 'prop-types';
import { useEffect } from 'react';
import ReactGA from 'react-ga';
import { withRouter } from 'react-router-dom';

function sendPageView(location) {
	ReactGA.set({ page: location.pathname });
	ReactGA.pageview(location.pathname);
}

// Listening to GA pages on every route
function GAListener({ children, history }) {
	useEffect(() => {
		ReactGA.initialize(import.meta.env.VITE_GOOGLE_ANALYTICS_ID);
		sendPageView(history.location);
		history.listen(sendPageView);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return children;
}

GAListener.propTypes = {
	children: PropTypes.node,
	trackingId: PropTypes.string,
	history: PropTypes.shape({
		listen: PropTypes.func
	})
};

export default withRouter(GAListener);
